export let ForterToken: string | undefined;

document.addEventListener("ftr:tokenReady", function(
    evt: Event & { detail?: string }
) {
    ForterToken = evt.detail;
});
